import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { UtilisateurSsoDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurSsoDto";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { mask } from "vue-the-mask";
import { UtilisateurExterneDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurExterneDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component({
	directives: { mask }
})
export default class ModalUtilisateurs extends Vue {
	public utilisateur: UtilisateurSsoDto = {
    	Id: 0,
    	EstArchive: false,
    	DateDeCreation: new Date(),
    	DateDeModification: new Date(),
    	RoleAdministrateur: false,
    	RoleAdministrateurPST: false,
    	RolePayeur: false,
    	RoleSalarie: false,
    	RoleUtilisateurPST: false
	};

	public verif = "";
	public isUpdate = false;
	public ifModeCongeActive = true;
	public isSubmitting = false;

	public listeSalarie: SalarieDto[] = [];
	public listeUtilisateursExternes: UtilisateurExterneDto[] = [];

	public customTokens: any = {
    	".": { pattern: /./ },
    	"#": { pattern: /\d/ },
    	X: { pattern: /[0-9a-zA-Z]/ },
    	Y: { pattern: /[a-zA-Z\- ]/ },
    	S: { pattern: /[a-zA-Z]/ },
    	A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
    	a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
    	"!": { escape: true },
    	T: { pattern: /[6-7]/ }
	}

	public mounted(): void {
    	if (ParametresInstance.societeCourante != undefined && this.listeSalarie.length == 0) {
    		ServicesFactoryInstance.SalarieService.getSalaries(data => {
    			this.listeSalarie = data.sort((a, b) => a.FullName != undefined && b.FullName != undefined && a.FullName > b.FullName ? 1 : -1);
    		});
    	}
    	ServicesFactoryInstance.UtilisateurExterneService.getListe(data => {
            this.listeUtilisateursExternes = data;
            this.listeUtilisateursExternes.sort(this.sortFunction);
    	});
	}

	public sortFunction(a: any, b: any): number {
    	return a.Nom != undefined && b.Nom != undefined && a.Nom > b.Nom ? 1 : -1;
	}

    public Init(IdUtilisateur?: number): void {
        this.isUpdate = IdUtilisateur != undefined;
        if (IdUtilisateur != undefined) {
            ServicesFactoryInstance.UtilisateurService.getUtilisateurById(IdUtilisateur, data => {
    			this.utilisateur = data;
    			if (data.MotDePasse != undefined) {
					this.verif = data.MotDePasse;
				}
    		});
		}
    	if (!this.isUpdate) {
    		this.verif = "";
    		this.utilisateur = {
    			Id: 0,
    			EstArchive: false,
    			DateDeCreation: new Date(),
    			DateDeModification: new Date(),
    			Email: "",
    			Initiales: "",
    			Login: "",
    			Prenom: "",
    			Nom: "",
    			Telephone: "",
    			RoleAdministrateur: false,
    			RoleAdministrateurPST: false,
    			RolePayeur: false,
    			RoleSalarie: false,
    			RoleUtilisateurPST: false
    		};
    	}
    	if (this.listeSalarie.length == 0) {
    		if (ParametresInstance.societeCourante != undefined && this.listeSalarie.length == 0) {
    			ServicesFactoryInstance.SalarieService.getSalaries(data => {
    				this.listeSalarie = data;
    			});
    		}
    	}

    	if (ParametresInstance.societeCourante == undefined) {
    		return;
    	}

    	this.ifModeCongeActive = ParametresInstance.societeCourante.IsModeCongeActive;
	}

	public checkUser(): boolean {
    	const errorMessage: string[] = [];
    	if (!this.isUpdate) {
    		if (this.utilisateur.Login != undefined && this.utilisateur.Login.length < 6) {
    			errorMessage.push("Le login doit faire au minimum 6 caractères");
    		}
    		if (this.verif != this.utilisateur.MotDePasse) {
    			errorMessage.push("Les mots de passe ne correspondent pas");
    		}
    	}
    	if (this.utilisateur.IdNotaire == -1) {
			this.utilisateur.IdNotaire = undefined;
		}

    	if (this.utilisateur.IdSalarie == -1) {
			this.utilisateur.IdSalarie = undefined;
		}

    	if (this.utilisateur.RoleSalarie && this.utilisateur.IdNotaire == undefined && this.utilisateur.IdSalarie == undefined) {
    		errorMessage.push("Un utilisateur ayant un rôle de salarié doit être associé à un salarié OU un notaire");
    	} else if (this.utilisateur.IdNotaire != undefined && this.utilisateur.IdSalarie != undefined) {
    		errorMessage.push("Un utilisateur ne peut être associé à un salarié ET à un notaire");
    	} else if (!this.utilisateur.RoleSalarie && this.utilisateur.IdNotaire != undefined) {
    		errorMessage.push("Un utilisateur associé un notaire doit avoir le rôle salarié");
    	} else if (!this.utilisateur.RoleSalarie && this.utilisateur.IdSalarie != undefined) {
    		errorMessage.push("Un utilisateur associé un salarié doit avoir le rôle salarié");
    	}

    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
    	}

    	return true;
	}

	public save(): void {
		if (this.checkUser()) {
			this.isSubmitting = true;
    		ServicesFactoryInstance.UtilisateurService.updateUtilisateur(this.utilisateur, data => {
    			this.utilisateur = data;
    			NotificationServiceInstance.SendSuccess("Utilisateur modifié avec succès.");
    			this.annuler();
				this.$emit("refresh");
				this.isSubmitting = false;
			}, () => {
				this.isSubmitting = false;
			});
    	}
	}

	public add(): void {
		if (this.checkUser()) {
			this.isSubmitting = true;
    		ServicesFactoryInstance.UtilisateurService.AddUtilisateur(this.utilisateur, data => {
    			this.utilisateur = data;
    			NotificationServiceInstance.SendSuccess("Utilisateur ajouté avec succès.");
    			this.annuler();
				this.$emit("refresh");
				this.isSubmitting = false;
			}, () => {
				this.isSubmitting = false;
			});
    	}
	}

	public annuler(): void {
    	$("#modalUtilisateurs").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/utilisateurs/modalUtilisateurs/modalUtilisateurs.ts